module.exports = __webpack_public_path__ + "img/swimming-pools.8fbceac.jpg";